// src/pages/ProjectDetails.jsx
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./ProjectDetails.css";

const backgroundStyle = {
  background: "url('/background.png') center/cover no-repeat",
  minHeight: "100vh"
};

function ProjectDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [project, setProject] = useState({});
  const [bids, setBids] = useState([]);
  const [editing, setEditing] = useState(false);
  const [updatedProject, setUpdatedProject] = useState({});
  const [bidsFetched, setBidsFetched] = useState(false);

  useEffect(() => {
    fetch(`http://localhost:5002/admin/project/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setProject(data);
        setUpdatedProject(data);
      })
      .catch((err) => console.error("Failed to load project", err));
  }, [id]);

  const handleUpdate = async () => {
    try {
      const response = await fetch(`http://localhost:5002/admin/updateproject/${id}`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(updatedProject),
      });

      if (!response.ok) throw new Error("Update failed");
      alert("Project updated!");
      setEditing(false);
    } catch (error) {
      console.error(error);
    }
  };

  const handleDelete = async () => {
    if (!window.confirm("Are you sure you want to delete this project?")) return;

    try {
      const res = await fetch(`http://localhost:5002/admin/deleteproject/${id}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      const data = await res.json();

      if (data.success) {
        alert("Project deleted");
        navigate("/admin/dashboard");
      } else {
        alert(data.message || "Delete failed");
      }
    } catch (err) {
      console.error("Delete error", err);
    }
  };

  const fetchBids = async () => {
    try {
      const res = await fetch(`http://localhost:5002/admin/viewbids/${id}`);
      const data = await res.json();
      setBids(data.sort((a, b) => a.bid_amount - b.bid_amount));
      setBidsFetched(true);
    } catch (err) {
      console.error("Fetch bids error", err);
    }
  };

  const allocate = async (studentId) => {
    try {
      const res = await fetch(`http://localhost:5002/admin/allocateproject`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ project_id: id, student_id: studentId }),
      });

      const data = await res.json();
      if (res.ok) {
        alert("Allocated!");
        fetchBids();
      } else {
        alert(data.error || "Allocation failed");
      }
    } catch (err) {
      console.error("Allocation error", err);
    }
  };

  const closeProject = async (statusId) => {
    try {
      const res = await fetch(`http://localhost:5002/admin/closeproject/${id}`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ status_id: statusId }),
      });

      if (!res.ok) throw new Error("Failed to close");
      alert(statusId === 2 ? "Marked as Completed" : "Marked as Failed");
      navigate("/admin/dashboard");
    } catch (err) {
      console.error("Close error", err);
    }
  };

  return (
    <div className="project-details-page" style={backgroundStyle}>
      <div className="project-container">
        <div className="project-main">
          <h2 className="project-title">{project.project_title}</h2>

          <div className="project-section">
            <strong>Client:</strong> {editing ? (
              <input value={updatedProject.client || ""} onChange={(e) => setUpdatedProject({ ...updatedProject, client: e.target.value })} />
            ) : project.client}
          </div>

          <div className="project-section">
            <strong>Overview:</strong> {editing ? (
              <textarea value={updatedProject.project_overview || ""} onChange={(e) => setUpdatedProject({ ...updatedProject, project_overview: e.target.value })} />
            ) : project.project_overview}
          </div>

          <div className="project-section">
            <strong>Scope:</strong> {editing ? (
              <textarea value={updatedProject.scope_of_work || ""} onChange={(e) => setUpdatedProject({ ...updatedProject, scope_of_work: e.target.value })} />
            ) : project.scope_of_work}
          </div>

          <div className="project-section">
            <strong>Technical Requirements:</strong> {editing ? (
              <input value={updatedProject.technical_requirements || ""} onChange={(e) => setUpdatedProject({ ...updatedProject, technical_requirements: e.target.value })} />
            ) : project.technical_requirements}
          </div>

          <div className="project-section">
            <strong>Deliverables:</strong> {editing ? (
              <textarea value={updatedProject.deliverables || ""} onChange={(e) => setUpdatedProject({ ...updatedProject, deliverables: e.target.value })} />
            ) : project.deliverables}
          </div>

          <div className="project-section">
            <strong>ETA:</strong> {editing ? (
              <input type="date" value={updatedProject.eta?.slice(0, 10) || ""} onChange={(e) => setUpdatedProject({ ...updatedProject, eta: e.target.value })} />
            ) : new Date(project.eta).toLocaleDateString()}
          </div>

          <div className="project-section">
            <strong>Changes Expected:</strong> {editing ? (
              <textarea value={updatedProject.changes || ""} onChange={(e) => setUpdatedProject({ ...updatedProject, changes: e.target.value })} />
            ) : project.changes}
          </div>

          <div className="project-section">
            <strong>Acceptance Criteria:</strong> {editing ? (
              <textarea value={updatedProject.acceptance_criteria || ""} onChange={(e) => setUpdatedProject({ ...updatedProject, acceptance_criteria: e.target.value })} />
            ) : project.acceptance_criteria}
          </div>

          <div className="project-section">
            <strong>Start Date:</strong> {new Date(project.start_date).toLocaleDateString()}
          </div>

          <div className="project-actions">
            {editing ? (
              <>
                <button onClick={handleUpdate}>Save</button>
                <button onClick={() => setEditing(false)}>Cancel</button>
              </>
            ) : (
              <>
                <button onClick={() => setEditing(true)}>Modify</button>
                <button onClick={handleDelete} style={{ background: "red", color: "white" }}>Remove Project</button>
              </>
            )}
          </div>
        </div>

        <div className="project-eta-box">
          <h3>Project ETA</h3>
          <p>{new Date(project.eta).toLocaleString()}</p>
        </div>
      </div>

      <div className="project-bids">
        <button onClick={fetchBids}>View Bids</button>

        {bidsFetched && bids.length === 0 && (
          <p>No bids have been made yet.</p>
        )}

        {bids.length > 0 && (
          <table>
            <thead>
              <tr>
                <th>Student Name</th>
                <th>Student ID</th>
                <th>Bid Amount</th>
                <th>Resume</th>
                <th>Contact</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {bids.map((bid) => (
                <tr key={bid.student_id}>
                  <td>{bid.username}</td>
                  <td>{bid.student_id}</td>
                  <td>{bid.bid_amount}</td>
                  <td>
                    {bid.resume_link ? (
                      <a href={bid.resume_link} target="_blank" rel="noopener noreferrer">View</a>
                    ) : (
                      "No Resume"
                    )}
                  </td>
                  <td>{bid.email || "N/A"}</td>
                  <td><button onClick={() => allocate(bid.student_id)}>Allocate</button></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {project.allocation_status === 1 && (
        <div className="status-buttons">
          <button className="completed" onClick={() => closeProject(2)}>Mark as Completed</button>
          <button className="failed" onClick={() => closeProject(3)}>Mark as Failed</button>
        </div>
      )}
    </div>
  );
}

export default ProjectDetails;
